// extracted by css-extract-rspack-plugin
export default {"search-and-cart":"SearchAndCart-module__search-and-cart--CWxQ3"};